









































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import fetch from "@/common/api/fetch";
import CONFIG from "@/common/config";

import getUrlParam from "@/common/utils/getUrlParam";
import getActivityType from "@/common/utils/getActivityType";
import appSuccess from "@/common/utils/appSuccess";
import { formatMoney } from "@/common/utils/format";
import { isXiaomaiApp, isMobile } from "@/common/utils/getPlaform";
import validForm from "@/common/utils/validForm";
import dealRouterPath from "@/common/filters/dealRoutePath";

import { AxiosPromiseData, State } from "@/common/interface";
import { Ladder } from "@/common/interface/group_type";

import MaterialModal from "@/components/common/index/MaterialModal.vue";
import DistributeConfirmModal from "@/pages/distributeType/components/edit/DistributeConfirmModal.vue";

const HIGHLIGHT_COLOR = "#FF6152";

@Component({
  components: {
    "material-modal": MaterialModal,
    "distribute-confirm-modal": DistributeConfirmModal
  }
})
export default class EditFooter extends Vue {
  @Prop() save!: Function;
  @Prop() cancle!: Function;

  @Getter("instId") instId!: string;
  @Getter("instIds") instIds!: Array<string>;
  @Getter("gradientColor") gradientColor!: string;
  @Getter("deadline") deadline!: string;
  @Getter("startTime") startTime!: string;
  @Getter("mainTextColor") mainTextColor!: string;
  @Getter("title") title!: string;
  @Getter("isLimited") isLimited!: string;
  @Getter("limitNum") limitNum!: number;
  @Getter("selectedBGM") selectedBGM!: object;
  @Getter("instPhone") instPhone!: string;
  // @Getter("activityRule") activityRule!: string;
  @Getter("activityIntros") activityIntros!: Array<object>;
  @Getter("contactInfo") contactInfo!: string;
  @Getter("institutionIntros") institutionIntros!: Array<object>;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("limitFlag") limitFlag!: boolean;
  @Getter("limitFlagNumber") limitFlagNumber!: number;
  @Getter("canPay") canPay!: boolean;
  @Getter("payType") payType!: string;
  @Getter("payNumber") payNumber!: number;
  @Getter("showFooter") showFooter!: boolean;
  @Getter("titleSection") titleSection!: any;
  @Getter("documentTitle") documentTitle!: string;
  @Getter("mustMinPay") mustMinPay!: boolean;
  @Getter("virtualGroup") virtualGroup!: boolean;
  @Getter("hasMaterialSaved") hasMaterialSaved!: boolean;
  @Getter("hasOpenSMSVerify") hasOpenSMSVerify!: boolean;

  getActivityType: Function = getActivityType;
  showMaterial: boolean = false;
  currentId: string = "";
  type: string = getUrlParam("type") as string;
  showConfirmModal: boolean = false;
  // 是否为分销模板
  isDistributeType :boolean = getActivityType() === 'distributeType'
  // 切换页面
  handleChangeView(): void {
    const source: string = getUrlParam("source") as string;
    const activityType: string = getActivityType() as string;
    if (this.type === "edit" || this.type === "reEdit") {
      this.$router.push({
        path: dealRouterPath("/" + activityType + "/index", "preview"),
      });
    } else if (this.type === "preview") {
      this.$router.push({
        path: dealRouterPath("/" + activityType + "/edit", source),
      });
      window.scrollBy(0, 1);
    }
    // if(this.type=='preview') {
    //   this.$router.go(-1);
    // }else {
    //   let link = (CONFIG.serverC as any)[process.env.VUE_APP_DEPLOY_ENV||'dev' as string];
    //   // link = 'http://localhost:8088';

    //   console.log('link',link,process.env.VUE_APP_DEPLOY_ENV)
    //   link+=`?instId=${getUrlParam("instId") || this.instId}#/aiEnroll?type=preview`;
    //   this.$router.push({
    //     path: '/poseType/index',
    //     query: {
    //       type: 'preview',
    //       url: link
    //     }
    //   })
    // }
  }

  handleSave() {
    const errMsg = validForm();
    if (errMsg) {
      Vue.$toast.error(errMsg);
      return;
    }
    if (window.hasValidated && !window.hasShowModal) {
      window.hasShowModal = true;
      return;
    }
    Vue.$confirm({
      text: `
          ${
            window.__wxjs_environment === "miniprogram"
              ? "确认发布吗"
              : "确认保存吗"
          }`,
      okText: "确定",
      ok: () => {
        this.handleSaveOk();
      },
      cancle: () => {
        this.$emit("cancle");
      }
    });
  }

  showMaterialModal() {
    this.showMaterial = true;
  }

  showDistributeConfirmModal() {
    const errMsg = validForm();
    if (errMsg) {
      Vue.$toast.error(errMsg);
      return;
    }
    this.showConfirmModal = true;
  }
  // 一键复制
  handleToCopy() {
    // 发送复制请求
    const data = this.getMaterialData();
    const adminId: string = getUrlParam("adminId") as string;
    fetch
      .Sales("anon/businessShow/saveMaterial", data)
      .then((res: AxiosPromiseData) => {
        // 没有复制成功就不跳转页面
        const { success } = res;
        if (success) {
          Vue.$toast.success("保存成功");
          if (isXiaomaiApp()) {
            appSuccess(this.currentId);
          } else {
            const env: string =
              (process.env.VUE_APP_DEPLOY_ENV as string) || "dev";
            let url=''
            if (env === 'prod') {
              url = 'https://res.xiaomai5.com/xmshow/index2.html#/';
            } else {
              url = (CONFIG.showUrl as any)[env];
            }
            if (this.type === "reEdit") {
              window.location.replace(
               url + "reEditSuccess"
              );
            } else {
              window.location.replace(url + "success");
            }
            parent.postMessage(
              {
                value: this.currentId,
                action: "saveActivity"
              },
              "*"
            );
          }
        }
      });
  }

  handleHiddenMaterailModal() {
    this.showMaterial = false;
    this.handleRedirectSuccPage(this.currentId);
  }

  // 隐藏分销类型的确认框
  handleHiddenConfirmModal() {
    this.showConfirmModal = false;
  }

// 扭蛋机获取prizes参数
  getParamsPrize() {
    const storeState: State = this.$store.state;
    const { gachaTypeParameter } = storeState;
    let { proList, addNum } = gachaTypeParameter.prize;
    let prizes = [];
    prizes = proList.map((item:any,index:number)=>{
      let { winningProbability, description, name, img,num,id } = item;

      return id ? {
        id,
        chanceOfWin: winningProbability,
        description,
        name,
        order:index,
        total: num,
        url: img
      }:
      {
        chanceOfWin: winningProbability,
        description,
        name,
        order:index,
        total: num,
        url: img
      };
    })
    return {prizes};
  }

  getParamAndContent() {
    return this.getAIEnrollContent();
  }
  getAIEnrollContent():{ parameter: any; content: any } {
    const storeState: State = this.$store.state;
    const {
      section,
      headReward,
      showBarrage,
      showData,
      documentTitle,
      // contactQrcode,
      groupImageList,
      viewBackground,
      ladderGroupList,
      signupItemConfig,
      hasOpenSMSVerify,
      instAddress
    } = storeState;
    const {
      originPrice,
      personNumber,
      groupNumber,
      courseDesc,
      courseName,
      coursePic
    } = section;
    const groupSizeList = ladderGroupList.map(item => item.groupSize);
    const groupSize = ladderGroupList[0].groupSize;
    const currentPrice = ladderGroupList[0].groupPrice;
    const parameter = {
      // groupSize,
      // groupSizeList,
      // needAuthCode: hasOpenSMSVerify,
      // needPay: this.canPay,
      // virtualGroup: this.virtualGroup,
      // groupNum: groupNumber,
      // participantType: storeState.groupSwitch,
      // minPrice: formatMoney(Number(currentPrice), 100),
      // maxPrice: formatMoney(originPrice, 100)
    };

    const content = {
      headReward,
      courseDesc,
      courseName,
      coursePic,
      showBarrage,
      showData,
      documentTitle,
      // contactQrcode,
      viewBackground,
      groupImageList,
      ladderGroupList,
      signupItemConfig,
      instAddress,
      payType: this.payType
    };
    return {
      parameter,
      content
    };

  }

  getMaterialData() {
    const storeState: State = this.$store.state;
    const { instName, groupImageList, contactQrcode } = storeState;
    const { content }: any = this.getParamAndContent();
    const { instPhone, contactInfo, institutionIntros } = content;
    const carousel = groupImageList.filter(img => {
      return img;
    });
    const contact = {
      contact: this.contactInfo,
      // qrcode: contactQrcode
    };
    const data = {
      instName,
      instId: getUrlParam("instId") || this.instId,
      instPhone: this.instPhone,
      carousel: JSON.stringify(carousel),
      contact: JSON.stringify(contact),
      introduction: JSON.stringify(this.institutionIntros)
    };
    return data;
  }

  getFormData() {
    const storeState: State = this.$store.state;
    const instId: string = getUrlParam("instId") as string;
    const orgId: string = getUrlParam("orgId") as string;
    const adminId: string = getUrlParam("adminId") as string;
    const activityType: string = getUrlParam("id") as string;
    const broadcastId: string = getUrlParam("broadcastId") as string;
    const instIds: any = this.instIds;
    const title: string = this.title;
    const deadline: number = Number(this.deadline);
    const startTime:number = Number(this.startTime);
    const { instName } = storeState;
    const { parameter, content }: any =this.getParamAndContent();
    const {prizes}:any = this.getParamsPrize();
    let cover = content.viewBackground ? content.viewBackground : content.groupImageList[0];
    // 去掉oss后缀
    if(!content.viewBackground && cover.includes('?')) {
    cover = cover.slice(0, (cover.indexOf('?')));
    }
    content.selectedBGM = this.selectedBGM;
    (content.instPhone = this.instPhone),
      // (content.activityRule = this.activityRule),
      (content.activityIntros = this.activityIntros),
      (content.contactInfo = this.contactInfo),
      (content.institutionIntros = this.institutionIntros),
      (content.xmMajordomo = storeState.xmMajordomo)


    const data = {
      title,
      instName,
      deadline,
      startTime,
      activityType,
      content: JSON.stringify(content),
      parameter: JSON.stringify(parameter),
      cover: cover
    };
    if(startTime){
      (data as any).startTime = startTime;
    }
    if (broadcastId) {
      (data as any).broadcastId = broadcastId;
    }
    if (instId) {
      (data as any).instId = instId;
    }
    if (orgId) {
      (data as any).orgId = orgId;
    }
    if (orgId && instIds) {
      (data as any).instIds = instIds.includes('0') ? storeState.instList.filter((item: any) => item && item.hasPay).map((item: any) => item.instId) : instIds;
    }
    if (adminId && adminId !== "unknown") {
      (data as any).adminId = adminId;
    }
    return data;
  }

  handleSaveOk() {
    const data: any = this.getFormData();

    !data.instId && delete data.instId;
    if (getUrlParam("type") != "reEdit" && (data.startTime > data.deadline)) {
      Vue.$toast.error("活动开始时间不能晚于截止时间");
      return;
    }
    const { activityType } = data;
    const adminId: string = getUrlParam("adminId") as string;
    const broadcastId: string = getUrlParam("broadcastId") as string;

    if (isXiaomaiApp()) {
      window.TDAPP.onEvent("点击【保存活动】", "APP端编辑", {
        来源: "APP端编辑"
      });
    } else if (isMobile()) {
      window.TDAPP.onEvent("点击【保存活动】", "扫码编辑", {
        来源: "扫码编辑"
      });
    } else {
      window.TDAPP.onEvent("点击【保存活动】", "电脑端编辑", {
        来源: "电脑端编辑"
      });
    }
    console.log('data-content', JSON.parse(data.content));
    // 小程序环境
    if (adminId) {
      const templateType = getActivityType();
      // 除了集赞类型
      if (templateType !== "tyType") {
        const apiUrl: string = (getUrlParam("broadcastId") && getUrlParam("state") != 'copy')
          ? "anon/show/saveActivity"
          : "anon/show/createAndReleaseActivity";
        (data as any).templateId = activityType;
        (data as any).activityId = broadcastId;
        fetch.newpost(apiUrl, data).then((res: AxiosPromiseData) => {
          Vue.$toast.success("发布成功");
          if (adminId == "unknown") {
            //跳转到登录界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/quick-login/main?id=${res.result}`
            });
          } else {
            //跳转到活动发布成功界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/activity/activityShare/main?id=${res.result}`
            });
          }
        });
      } else {
        const apiUrl: string = (getUrlParam("broadcastId") && getUrlParam("state") != 'copy')
          ? "c/xm/show/save"
          : "c/xm/show/addAndRelease";
        fetch.post(apiUrl, data).then((res: AxiosPromiseData) => {
          Vue.$toast.success("发布成功");
          if (adminId == "unknown") {
            //跳转到登录界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/quick-login/main?id=${res.data}`
            });
          } else {
            //跳转到活动发布成功界面
            window.wx.miniProgram.redirectTo({
              url: `/pages/activity/activityShare/main?id=${res.data}`
            });
          }
        });
      }
    } else {
      const templateType = getActivityType();
      (data as any).templateId = activityType;
      (data as any).activityId = broadcastId;
      const apiUrl: string = (getUrlParam("broadcastId") && getUrlParam("state") != 'copy')
        ? "sales/anon/admissions/saveActivity"
        : "sales/anon/admissions/createActivity";
      fetch.pureUrl(apiUrl, data).then((res: AxiosPromiseData) => {
        this.currentId = res.result;
        const orgId: string = getUrlParam("orgId") as string;
        this.handleRedirectSuccPage(res.result);
        return;
      });
    }
  }

  // 跳转到成功页面
  handleRedirectSuccPage(broadcastId: string) {
    Vue.$toast.success("保存成功");
    if (isXiaomaiApp()) {
      appSuccess(broadcastId);
    } else {
      const env: string = (process.env.VUE_APP_DEPLOY_ENV as string) || "dev";
      let url=''
      if (env === 'prod') {
        url = 'https://res.xiaomai5.com/xmshow/index2.html#/';
      } else {
        url = (CONFIG.showUrl as any)[env];
      }
      if (this.type === "reEdit") {
        window.location.replace(url + "reEditSuccess");
      } else {
        window.location.replace(url + "success");
      }
      parent.postMessage(
        {
          value: broadcastId,
          action: "saveActivity"
        },
        "*"
      );
    }
  }
}
